export default "__VITE_ASSET__b7fae54e__"